import React from "react";

const Home = () => (
  <div className={'bg-image'} id={'home'}/>
);

export default Home;
